import idleCallback, { timings } from "common/utils/ui/idle_callback";
import { waitForWindowVariable } from "common/utils/ui/wait_for";
import { isIframe } from "common/utils/ui/browser";
import { isMobileBrowser } from "common/utils/browser";
import { isCartPage } from "common/utils/pages";

const $googleBadgeIcon = () => document.getElementById("merchantwidget-iframe-wrapper");

const executeTopQualityStore = () => {
  // eslint-disable-next-line no-undef
  merchantwidget.start({
    position: "LEFT_BOTTOM",
    sideMargin: 15,
    bottomMargin: 50,
    mobileSideMargin: 15,
    mobileBottomMargin: 5
  });

  const $element = $googleBadgeIcon();

  if ($element) {
    $element.classList.add("google-top-quality-store");
  }
};

const initTopQualityStoreScript = () => {
  const script = document.createElement("script");
  script.async = true;

  script.src = "https://www.gstatic.com/shopping/merchant/merchantwidget.js";
  document.body.appendChild(script);
};

const skipWidget = () => isCartPage() && (isMobileBrowser() || Boolean(window.MOBILE_APP));

window.addEventListener("load", () => {
  // Stop loading the badge if the page is loaded in an iframe
  if (isIframe()) {
    console.debug("GoogleTopQualityStore loading skipped inside the iframe"); // eslint-disable-line no-console
    return;
  }

  // Don't show widget on cart page when customer is on mobile (app or browser)
  if (skipWidget()) {
    return;
  }

  idleCallback(initTopQualityStoreScript, timings.topQualityStore);
  waitForWindowVariable(
    "merchantwidget",
    () => {
      executeTopQualityStore();
    },
    () => {
      console.error("GoogleTopQualityStore is not loaded"); // eslint-disable-line no-console
    }
  );
});
